import React from 'react';

import { DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { UserDto, UserDtoProfileEnum } from 'lib_api/lib/api/gen';

import { useUserStore } from 'hooks/UserStoreContext';

import './PieceJointeItem.less';

interface PieceJointeItemProps {
  text: string;
  onDeleted: () => void;
}

const PieceJointeItem = ({ text, onDeleted }: PieceJointeItemProps) => {
  function handleDelete(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();
    onDeleted();
  }

  const user: UserDto = useUserStore();
  const isAdmin = user.profile === UserDtoProfileEnum.ADMIN_FONCTIONNEL;

  return (
    <div className={'imported-file-item'}>
      <div>{text}</div>
      {isAdmin && (
        <Button
          icon={<DeleteOutlined />}
          onClick={handleDelete}
          className={'file-delete-button'}
        />
      )}
    </div>
  );
};

export default PieceJointeItem;
